
























































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import FileHandler from '@/mixins/file-handler'
import moment from 'moment'
import { IMAGE_ACCEPT_TYPES, prepareImageForUpload } from '@/utils/image-compress'
import { showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'

@Component({})
export default class AppMultiImagesUploader extends mixins(FileHandler) {
  @Prop({ type: Array }) readonly urls!: string[];
  @Prop({ type: Array }) readonly ids!: number[];
  @Prop({ type: [Number, String], default: '588' }) readonly width!:
    | number
    | string;

  @Prop({ type: String }) readonly label!: string;
  @Prop({ type: Boolean }) readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  imageUrls: string[] = [];
  imageIds: number[] = [];

  ossPath = '';

  targetImage: any = null;

  // 封面仅允许常见图片格式
  imageAcceptTypes = IMAGE_ACCEPT_TYPES.join(',');

  // 压缩/上传中，防止重复点击
  uploading = false;

  mounted () {
    // 数据在更新的时候比这一步操作慢
    if (this.urls) {
      this.imageUrls = [...this.urls]
    }
    if (this.ids) {
      this.imageIds = this.ids.map((id) => +id)
    }
  }

  addFile () {
    if (this.disabled || this.uploading) {
      return false
    }
    const elem = this.$refs.fileBrowser as Vue & {
      click: () => boolean;
      value: string | null;
    }

    elem.value = null
    elem.click()
  }

  previewImage (url: string) {
    this.targetImage = url
  }

  closePreview () {
    this.targetImage = null
  }

  async onFileChanged (e: any) {
    const files = e.target.files || e.dataTransfer.files
    const file: File | undefined = files && files[0]
    if (!file || this.uploading) {
      return
    }

    this.uploading = true
    try {
      // 校验类型与大小（上限 20MB），并按规则缩放/压缩，详见 image-compress.ts
      this.fileToUpload = await prepareImageForUpload(file)

      if (!this.checkCredentialValid()) {
        await this.getOSSCredentials()
      }

      const extension = this.$R.last(this.fileToUpload.name.split('.'))
      // 上传文件夹
      this.ossPath =
        'goods_covers/' +
        moment().format('YYYY/MM/DD') +
        moment().unix() +
        '.' +
        extension

      // 修改商品的coverImages
      await this.uploadFileToOSS(this.imageUrls)
    } catch (err) {
      this.fileToUpload = null
      showNotification({
        msg: (err && err.message) || '图片上传失败，请重试',
        type: SnackType.Error
      })
    } finally {
      this.uploading = false
    }
  }

  // 删除图片：1.从urls数组删除，2.从阿里云删除对象
  async deleteImage (index: number) {
    if (!this.disabled) {
      this.imageUrls = this.$R.remove(index, 1, this.imageUrls)
    }
  }

  @Watch('imageUrls', { deep: true })
  onValueChanged (val: string[]) {
    this.$emit('changed', {
      urls: val,
      ids: this.imageIds
    })
  }

  @Watch('fileUploaded', { deep: true })
  onUploadedChanged (val: any) {
    this.imageUrls = val
  }

  @Watch('urls', { deep: true })
  onValueChanged1 (val: string[]) {
    this.imageUrls = val
  }
}
